import CarrinhoItemModel from "./CarrinhoItemModel";
import ProdutoModel from "./ProdutoModel";

export default class C5CompraItemModel {
  public compraId: string = "";
  public produtoId: string = "";
  public nome: string = "";
  public quantidade: number = 0;
  public precoUnitario: number = 0;
  public fatorMultiplicacao: number = 0;
  public precoUnitarioDesconto: number = 0;
  public totalItem: number = 0;
  public unidade: string = "";
  public notas: string = "";

  public static toModel(item: any): C5CompraItemModel {
    return {
      compraId: item.SaleID,
      produtoId: item.ProductID,
      nome: item.ProductName,
      quantidade: item.Quantity,
      precoUnitario: item.AmountUnity,
      totalItem: item.TotalAmount,
      unidade: item.SaleUnit,
      fatorMultiplicacao: item.WeightMultiplierFactor,
    } as C5CompraItemModel;
  }

  public toCarrinhoItemModel(compraId: string): CarrinhoItemModel {
    const produto: ProdutoModel = new ProdutoModel();
    produto.nome = this.nome;
    produto.produtoId = this.produtoId;
    produto.precoDesconto = this.precoUnitario;
    produto.precoOriginal = this.precoUnitario;
    produto.fatorMultiplicacao = this.fatorMultiplicacao;
    produto.unidade = this.unidade;

    return {
      compraId: compraId,
      produto,
      quantidade: this.quantidade,
      carrinhoItemId: "",
      notas: "",
      adicionado: new Date()
    } as CarrinhoItemModel;
  }
}